import type { Locale } from '@/i18n'

const applicationTabsTranslations = {
  uk: {
    civil: 'Для цивільних',
    military: 'Для військових',
  },
  en: {
    civil: 'For Civilians',
    military: 'For Military',
  },
}

export const getApplicationTabsTranslations = (locale: Locale) =>
  applicationTabsTranslations[locale]

const civilFormTranslations = {
  uk: {
    // Fields
    fullName: "Прізвище та ім'я",
    fullNamePlaceholder: 'ШЕВЧЕНКО Тарас',
    age: 'Вік',
    agePlaceholder: '25',
    phone: 'Номер мобільного телефону',
    phonePlaceholder: '+38 099 111 11 11',
    position: 'Яка роль в команді є для тебе бажаною?',
    positionPlaceholder: 'Вкажіть бажану посаду',
    hobbies: 'Хоббі та захоплення',
    hobbiesPlaceholder: 'Ваші хоббі та захоплення',
    submit: 'Надіслати заявку',
    required: '*',
  },
  en: {
    // Fields
    fullName: 'Surname and Name',
    fullNamePlaceholder: 'SHEVCHENKO Taras',
    age: 'Age',
    agePlaceholder: '25',
    phone: 'Mobile Phone Number',
    phonePlaceholder: '+38 099 111 11 11',
    position: 'Desired Position',
    positionPlaceholder: 'Enter desired position',
    hobbies: 'Hobbies and Interests',
    hobbiesPlaceholder: 'Your hobbies and interests',
    submit: 'Submit Application',
    required: '*',
  },
}

export const getCivilFormTranslations = (locale: Locale) => civilFormTranslations[locale]

const militaryFormTranslations = {
  uk: {
    // Fields
    position: 'Яка роль в команді є для тебе бажаною?',
    positionPlaceholder: 'Оберіть посаду',
    fullName: "Прізвище та ім'я",
    fullNamePlaceholder: 'ШЕВЧЕНКО Тарас',
    age: 'Вік',
    agePlaceholder: '25',
    militaryRank: 'Військове звання',
    militaryRankPlaceholder: 'Солдат',
    bzpvCompleted: 'Чи проходив БЗВП?',
    yes: 'Так',
    no: 'Ні',
    szcStatus: 'Чи перебуваєш у статусі "СЗЧ"?',
    phone: 'Номер мобільного телефону',
    phonePlaceholder: '+38 099 111 11 11',
    submit: 'Надіслати заявку',
    required: '*',
  },
  en: {
    // Fields
    position: 'Desired Position',
    positionPlaceholder: 'Select position',
    fullName: 'Surname and Name',
    fullNamePlaceholder: 'SHEVCHENKO Taras',
    age: 'Age',
    agePlaceholder: '25',
    militaryRank: 'Military Rank',
    militaryRankPlaceholder: 'soldier',
    bzpvCompleted: 'Have you completed BZPV?',
    yes: 'Yes',
    no: 'No',
    szcStatus: 'Are you in "SZCh" status?',
    phone: 'Mobile Phone Number',
    phonePlaceholder: '+38 099 111 11 11',
    submit: 'Submit Application',
    required: '*',
  },
}

export const getMilitaryFormTranslations = (locale: Locale) => militaryFormTranslations[locale]
